import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    ExclamationCircleOutlined,
    LoadingOutlined,
} from "@ant-design/icons";
import { List, Progress } from "antd";
import styled from "styled-components";

import { QueueTaskSnapshot } from "@/hooks/core/useAsyncTaskQueue";
import { PrimaryText } from "@/shared/ui/Typography";

export const StyledProgress = styled(Progress)`
    .ant-progress-text {
        color: ${({ theme }) => theme.colors.white};
    }
`;

export const StyledLoaderContainer = styled.div`
    position: fixed;
    flex-direction: column;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 3000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
    padding: 16px;

    & .network-indicator {
        top: 32px;
        left: 32px;
    }
`;

export const StyledList = styled(List<QueueTaskSnapshot>)`
    padding-inline: 8px;
    width: 100%;
`;

export const StyledContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
    padding: 16px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.4);

    max-width: ${({ theme }) => theme.maxContentWidth};
`;

const iconDimension = "16px";

export const StyledLoadingOutlined = styled(LoadingOutlined)`
    font-size: ${iconDimension};
    color: ${({ theme }) => theme.additionalTypographyColor};
`;

export const StyledExclamationCircleOutlined = styled(
    ExclamationCircleOutlined,
)`
    font-size: ${iconDimension};
    color: ${({ theme }) => theme.dangerTypographyColor};
`;

export const StyledClockCircleOutlined = styled(ClockCircleOutlined)`
    font-size: ${iconDimension};
    color: ${({ theme }) => theme.disabledTypographyColor};
`;

export const StyledCheckCircleOutlined = styled(CheckCircleOutlined)`
    font-size: ${iconDimension};
    color: ${({ theme }) => theme.successTypographyColor};
`;

export const StyledTextItem = styled(PrimaryText)`
    opacity: 0.7;
`;

export const StyledNetworkIndicatorWrapper = styled.div`
    position: absolute;
    left: 45px;
    top: 16px;
`;
